<template>
  <div>
    <hr />
    <Filters @paginate="handleFilters" :loading="loading" />
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length == 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <v-data-table
        dense
        v-show="data.length > 0"
        :headers="headers"
        :items="data"
        :footer-props="{
          'items-per-page-options': [25, 50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.status`]="{ item }">
          <small class="mr-2">AGUARDANDO PAGAMENTO</small>
          <v-icon color="primary" small>mdi-clock-outline</v-icon>
          <input type="hidden" :value="item.status" />
        </template>
        <template v-slot:[`item.plan`]="{ item }">
          {{ handleType(item.resident_has_accommodation_type) }}
        </template>
        <template v-slot:[`item.information`]="{ item }">
          <p
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">VALOR DA DIÁRIA:</span>
            <strong>{{
              formatReal(item.resident_has_accommodation_value)
            }}</strong>
          </p>
          <div
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">QUANTIDADE DE DIÁRIAS:</span>
            <strong>{{ item.resident_has_accommodation_daily_amount }}</strong>
          </div>
          <p
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">TOTAL DO PERÍODO:</span>
            <strong>{{ formatReal(item.value) }}</strong>
          </p>
        </template>
        <template v-slot:[`item.due_date`]="{ item }">
          {{ formatDate(item.due_date, false) }}
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ formatReal(item.value) }}
        </template>
        <template v-slot:[`item.note`]="{ item }">
          {{ item.note }}
        </template>
      </v-data-table>
    </b-overlay>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import Filters from "../../Components/Filters.vue";

import api from "../../../services/api";

import { formatDate, formatReal } from "../../../lib/format";

import moment from "moment";

export default {
  name: "AwaitingPayment",

  components: {
    ErrorsMessages,
    Filters,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      month: moment().format("YYYY-MM"),
      dayMonthYear: "month",

      status: 2,

      data: [],

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "PLANO", value: "plan", sortable: false },
        { text: "INFORMAÇÕES", value: "information", sortable: false },
        { text: "VENCIMENTO", value: "due_date", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "OBSERVAÇÃO", value: "note", sortable: false },
      ],

      items: [],

      loading: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    formatReal,
    moment,

    handleFilters(filters) {
      let { month, dayMonthYear } = filters;

      this.month = month;
      this.dayMonthYear = dayMonthYear;

      this.paginate();
    },

    handleType(type) {
      return (
        {
          DIARIA: "DIÁRIA",
          MENSAL: "MENSAL",
        }[type] || "NÃO ENCONTRADO"
      );
    },

    retrieve() {
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, status, month, dayMonthYear } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          status,
          page,
          itemsPerPage,
          month,
          dayMonthYear,
        };

        const response = await api.get(
          "/rest-home/resident-financial-accommodations",
          {
            params,
          }
        );

        const { data, total } = response.data;

        this.data = data;
        this.total = total;
        this.$bvModal.hide("filter");

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
